import React from 'react';
import './services.css';
import { useTranslation } from './LanguageContext';


export default function Services({ onAnalyseClick }) {
  const { t } = useTranslation();
  return (
    <section id="features" className="section">
      <div className="container">
        <div className="section-title">
          <h2>{t('services.title')}</h2>
        </div>

        <div className="features-grid">
          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/protection.png" alt={t('services.card1.alt')} loading="lazy" />
            </div>
            {/* <span className="badge">{t('services.badge.popular')}</span> */}
            <h3>{t('services.card1.title')}</h3>
            <p>{t('services.card1.desc')}</p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/liste-de-travail.png" alt={t('services.card2.alt')} loading="lazy" />
            </div>
            {/* <span className="badge badge-soft">{t('services.badge.new')}</span> */}
            <h3>{t('services.card2.title')}</h3>
            <p>{t('services.card2.desc')}</p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/resultats.png" alt={t('services.card3.alt')} loading="lazy" />
            </div>
            {/* <span className="badge badge-soft">{t('services.badge.soon')}</span> */}
            <h3>{t('services.card3.title')}</h3>
            <p>{t('services.card3.desc')}</p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/detection-des-menaces.png" alt={t('services.card4.alt')} loading="lazy" />
            </div>
            <h3>{t('services.card4.title')}</h3>
            <p>{t('services.card4.desc')}</p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/recherche.png" alt={t('services.card5.alt')} loading="lazy" />
            </div>
            <h3>{t('services.card5.title')}</h3>
            <p>{t('services.card5.desc')}</p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <img src="/icons/detection.png" alt={t('services.card6.alt')} loading="lazy" />
            </div>
            <h3>{t('services.card6.title')}</h3>
            <p>{t('services.card6.desc')}</p>
          </div>

          
        </div>
      </div>
    </section>
  );
}

